module.exports = __webpack_public_path__ + "static/media/quarter_circ.69377ec3.svg";